import { render } from "./LoadingScreen.vue?vue&type=template&id=2818dc88&scoped=true"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=2818dc88&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\iab_b\\Documents\\Dev\\OA\\woah-transfer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2818dc88"]])

export default __exports__